import { tokens } from '@/modules/utils/themeUtils';
import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const StyledVehicleCards = styled.div(
  ({ theme }) => `
      background: linear-gradient(
      180deg,
      rgba(237, 242, 247, 0) -7.11%,
      ${tokens.globalColors.vLightGrey} 62.29%
      );
      padding: ${theme.size.static250} 0;
  
    @media(min-width: ${Breakpoints.b960}px) {
      padding: ${theme.size.static550} 0;
    }
  `
);

export const StyledVehicleCardsNav = styled.div(
  ({ theme }) => `
      background: ${tokens.globalColors.vLightGrey};
      padding: ${theme.size.static250} 0;
    `
);
